function ajaxCall(obj)
{
	//console.log(obj.data)
	var deferred = $.Deferred();
	$.ajax({
		url: obj.url,
		type: "POST",
		data:(obj.data)?obj.data:"",
		beforeSend: function(xhr){
			//loadng effect...
			if(!obj.is_from_batch_number_check){
				$(".loading").show();
			}
		},
		success:function(data){
			if(data){
				deferred.resolve(data);
			}else{
				deferred.reject(data);
			}
		},
		error:function(data, status, errorThrown){
			var http_code = [400, 401];
            if(status == 403){//403
                deferred.resolve(data);
            }else{
                if(http_code.indexOf(status) != -1){
                    deferred.reject(data);
                }else{
                    deferred.reject(data);
                }
            }
		}
	});
	return deferred.promise();

}